import React, { useEffect, useState } from 'react';
import NavContainer from './Nav';
import OffCanvasNav from './OffCanvasNav';
import { Table, Button, Modal, Form, Alert } from "react-bootstrap";
import { dotoniwoofApi } from '../api/dotoniwooApi';
import { useAuth } from '../context/AuthContext';
import Titulo from '../elements/Titulo';
import { Helmet } from 'react-helmet';
import Pagination from './Pagination';

const StockManagment = () => {

  const { user } = useAuth();
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [newStock, setNewStock] = useState("");
  const [newProductStock, setNewProductStock] = useState("");
  const [newProductPrice, setNewProductPrice] = useState("");
  const [products, setProducts] = useState([]);
  const filteredProducts = products.filter((product) =>
    product.item_description.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [message, setMessage] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const totalPages = Math.ceil(products.length / itemsPerPage);





  useEffect(() => {
    getStockItems();
  }, [])

  const getStockItems = async (page) => {
    await dotoniwoofApi.get(`/stock.php`)
      .then(res => {
        let responseApi = res.data;
        if (responseApi.code === 200) {
          setProducts(responseApi.message);
        }

      })
      .catch(err => {
        console.log(err);
      }).finally(
        () => {
        }
      )
  };

  const currentItems = filteredProducts.slice(indexOfFirstItem, indexOfLastItem);
  const sortItems = [...currentItems].sort((a, b) => {
      return a.item_description.localeCompare(b.item_description);
  });
  

  const handleUpdateStock = (product) => {
    setSelectedProduct(product);
    setNewStock(product.stock); // Prellenar con el stock actual
    setShowModal(true);
  };

  const handleStockAdd = (product) => {
    setSelectedProduct(product);
    setNewProductPrice(product.price);
    setNewProductStock(product.stock);  // Prellenar con el stock actual
    setShowModalAdd(true);
  };

  const handleSaveStock = () => {
    const updatedProducts = products.map((product) =>
      product.id === selectedProduct.id
        ? { ...product, stock: newStock }
        : product
    );
    setProducts(updatedProducts);
    setShowModal(false);
    updateProduct(selectedProduct);
  };


  const handleSaveStockAdd = () => {
    setShowModalAdd(false);
    createNewItem(selectedProduct);
  };



  const createNewItem = async (selectedProduct) => {
    await dotoniwoofApi.post(`/stock.php`,
      JSON.stringify({
        firebase_UID: user.uid,
        id_item: selectedProduct.id_item,
        id_supplier: selectedProduct.id_supplier,
        stock: newProductStock,
        price: newProductPrice
      })
    ).then((res) => {
      if (res.status == 201) {
        setMessage("Registro Creado con éxito")
        setShowSuccessAlert(true);
        setTimeout(() => setShowSuccessAlert(false), 2000);
        getStockItems();
      }
    })

      .catch(err => {
        console.log(err);
      }).finally(
        () => {
        }
      )
  }

  const updateProduct = async (selectedProduct) => {
    await dotoniwoofApi.put(`/stock.php/${selectedProduct.id_pricing}`,
      JSON.stringify({
        firebase_UID: user.uid,
        stock: newStock
      })
    ).then((res) => {
      if (res.status == 204) {
        setMessage("Registro actualizado con éxito")
        setShowSuccessAlert(true);
        setTimeout(() => setShowSuccessAlert(false), 2000);
      }
    })

      .catch(err => {
        console.log(err);
      }).finally(
        () => {
        }
      )
  }


  return (
    <>
      <NavContainer></NavContainer>
      <OffCanvasNav></OffCanvasNav>
      <Helmet><title>
        Administración de stock
      </title></Helmet>

      <div className="container mt-4">
        <Titulo>Administración de stock</Titulo>
        <br></br>
        {/* Alerta de confirmación de éxito */}
        {showSuccessAlert && (
          <Alert variant="success">
            {message}
          </Alert>
        )}
        {/* Alerta de error */}
        {showErrorAlert && (
          <Alert variant="danger">
            ERROR AL CREAR EL PRODUCTO
          </Alert>
        )}


        {/* Input para filtrar productos */}
        <Form.Control
          type="text"
          placeholder="Buscar producto..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="mb-3"
        />
         <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    paginate={paginate}
                />
                <br></br>
        {/* Tabla con productos filtrados */}
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Producto</th>
              <th>Stock</th>
              <th>Color</th>
              <th>Talla</th>
              <th>Peso</th>
              <th>Precio</th>
              <th>Fecha Actualización</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {sortItems.map((product) => (
              <tr key={product.id_pricing}>
                <td>{product.item_description}</td>
                <td>{product.stock}</td>
                <td>{product.color}</td>
                <td>{product.size}</td>
                <td>{product.weight}</td>
                <td>{product.price}</td>
                <td>{product.effective_date}</td>
                <td>
                  <Button style={{ margin: '2px' }}
                    variant="primary"
                    onClick={() => handleUpdateStock(product)}
                  >
                    Actualizar Stock
                  </Button>
                  <Button style={{ margin: '2px' }}
                    variant="success"
                    onClick={() => handleStockAdd(product)}
                  >
                    Agregar con otro precio
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>


        {/* Modal para actualizar el stock */}
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Actualizar Stock</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group>
                <Form.Label>Producto</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedProduct?.item_description}
                  readOnly
                />
              </Form.Group>

              <Form.Group>
                <Form.Label>Nuevo Stock</Form.Label>
                <Form.Control
                  type="number"
                  value={newStock}
                  onChange={(e) => setNewStock(e.target.value)}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Cancelar
            </Button>
            <Button variant="primary" onClick={handleSaveStock}>
              Guardar Cambios
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Modal para actualizar el stock */}
        <Modal show={showModalAdd} onHide={() => setShowModalAdd(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Nuevo precio</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group>
                <Form.Label>Producto</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedProduct?.item_description}
                  readOnly
                />
              </Form.Group>

              <Form.Group>
                <Form.Label>Nuevo Precio</Form.Label>
                <Form.Control
                  type="number"
                  onChange={(e) => setNewProductPrice(e.target.value)}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Nuevo Stock</Form.Label>
                <Form.Control
                  type="number"
                  onChange={(e) => setNewProductStock(e.target.value)}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModalAdd(false)}>
              Cancelar
            </Button>
            <Button variant="primary" onClick={handleSaveStockAdd}>
              Guardar Cambios
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

    </>
  );
}

export default StockManagment;